import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";
import { PAYOUTS_QUERY_KEY } from "../contsants";
import { useEffect } from "react";
import { CampaignService } from "../services/Campaign.service";
import { IGetPayoutsRequest } from "@shared/lib/types/briefCampains";

export function useGetPayouts(params: IGetPayoutsRequest) {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [...PAYOUTS_QUERY_KEY(), params],
    queryFn: () => CampaignService.getPayouts(params),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    payouts: data?.data,
    isLoading,
    isError,
    refetch,
  };
}
